module.exports = __webpack_public_path__ + "static/media/class_job_022.b92bce26.svg";